var _rect, _circle, _circle2, _circle3, _circle4, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _rect12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPollBattleBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1366,
    height: 650,
    viewBox: "0 0 1366 650",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_4501)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 650,
    rx: 20,
    fill: "#E0D6F4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 706.5,
    cy: 989.5,
    r: 1062.5,
    fill: "#E0D6F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 706.5,
    cy: 989.5,
    r: 831.5,
    fill: "#E0D6F4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 706.5,
    cy: 989.5,
    r: 574.5,
    fill: "#E0D6F4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 706.5,
    cy: 989.5,
    r: 393.5,
    fill: "#E0D6F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 153,
    y: 222.56,
    width: 51.0371,
    height: 106.449,
    rx: 10,
    transform: "rotate(-36.7832 153 222.56)",
    fill: "#E0D6F4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.2133,
    y: 352,
    width: 51.0371,
    height: 106.449,
    rx: 10,
    transform: "rotate(44.2007 74.2133 352)",
    fill: "#E0D6F4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1269,
    y: 117.811,
    width: 51.0371,
    height: 106.449,
    rx: 10,
    transform: "rotate(-7.66934 1269 117.811)",
    fill: "#E0D6F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1138.31,
    y: 28,
    width: 51.0371,
    height: 106.449,
    rx: 10,
    transform: "rotate(42.7882 1138.31 28)",
    fill: "#E0D6F4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 110.894,
    y: -19,
    width: 51.0371,
    height: 106.449,
    rx: 10,
    transform: "rotate(27.3434 110.894 -19)",
    fill: "#E0D6F4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 474.644,
    width: 51.0371,
    height: 106.449,
    rx: 10,
    transform: "rotate(-13.1877 244 474.644)",
    fill: "#E0D6F4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 1194.87,
    y: 207,
    width: 51.0371,
    height: 106.449,
    rx: 10,
    transform: "rotate(25.528 1194.87 207)",
    fill: "#E0D6F4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 1143.35,
    y: 520.574,
    width: 51.0371,
    height: 106.449,
    rx: 10,
    transform: "rotate(-27.907 1143.35 520.574)",
    fill: "#E0D6F4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1269,
    y: 424.73,
    width: 51.0371,
    height: 106.449,
    rx: 10,
    transform: "rotate(-39.8885 1269 424.73)",
    fill: "#E0D6F4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 577.561,
    width: 51.0371,
    height: 106.449,
    rx: 10,
    transform: "rotate(-36.7832 55 577.561)",
    fill: "#E0D6F4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168.319 450.276L552.632 126.053L490.854 503.412L831.764 146.822L783.774 524.565C883.345 417.729 1083.94 231.676 1158.4 188.623",
    stroke: "#E0D6F4",
    strokeWidth: 210.276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1365,
    height: 649,
    rx: 19.5,
    stroke: "#EDEDEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_4501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 650,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollBattleBackground);
export default __webpack_public_path__ + "static/media/poll-battle-background.7bade44f42e2f842943333a8fdbf143a.svg";
export { ForwardRef as ReactComponent };